import ko from 'knockout';
import $ from 'jquery';
import templateMarkup from 'raw-loader!./endpointhistoricalcalls-widget.html';
import moment from 'moment-timezone';
import _ from 'lodash';
import DataProvider from "../../../app/data-framework/data-provider";
import LoginService from "../../../services/login.service";
        

        function EndpointHistoricalCalls(params) {

            var self = this;
            self.params = params;
            this.observableOptions = params.observableOptions;
            this.observableData = params.observableData;
            self.panelTemplate = params.panelTemplate;
            self.widgetSignals = params.widgetSignals;

            self.subscriptions = [];

            self.dataProvider = DataProvider.getInstance();

            self.timeZone = { id: _.get(LoginService.userObject, 'timezoneId', ''), text: _.get(LoginService.userObject, 'timezoneDisplay', '') };

            var end = moment().endOf('month');
            var start = moment().startOf('month');

            if (end.get('date') !== moment().get('date')) {
                end = moment().subtract(1, 'month').endOf('month');
                start = moment().subtract(1, 'month').startOf('month');
            }

            self.selectedDateRangeValues = ko.observable({ startDate: start, endDate: end });

            self.getObsParams = function(optschanged) {

                if (!params.observableParamsList) {
                    return null;
                }

                var obsparams = params.observableParamsList[0]();

                self.historicalId = (params.viewLevelOptions && params.viewLevelOptions() && params.viewLevelOptions().historicalId) ? params.viewLevelOptions().historicalId : null;

                if (self.historicalId) {

                    obsparams.queryId = "FlexAccessQueryWithMetadata";

                    var paramsTemp = {
                        inpStartDate: self.selectedDateRangeValues().startDate.format("YYYY/MM/DD"),
                        inpEndDate: self.selectedDateRangeValues().endDate.format("YYYY/MM/DD")
                    };

                    var options = params.observableOptions();

                    paramsTemp.pageNum = (optschanged === true) ? options.pageNum : 1;
                    paramsTemp.pageSize = options.pageSize;

                    paramsTemp.dataset = options.dataset;

                    paramsTemp.aggregatefact = '';
                    paramsTemp.groupby = '';
                    paramsTemp.timegrain = '';
                    paramsTemp.tag = '';

                    let valueType = LoginService.userObject.farmG2 ? 'uuid' : 'numeric';

                    paramsTemp
                        .WhereCondition =
                        '[{"conditions":[{"id":1,"selectedLhs":"dimEndpoint.dimEndpointSID","selectedOperator":"=","rhsText":"' + self.historicalId + '","rhsCount":"","listtype":false,"valueType":"'+ valueType +'","selectedRhs":[],"selectedConjunction":"AND","conjunctionVisible":false,"hidden":false,"lhstitle":"Endpoint Id","optitle":"equals","loadMode":false}],"conjunctionVisible":false}]';

                    var display = params.panelTemplate.defaultOptions.display;

                    paramsTemp.sortColumn = "";
                    if (display && !$.isEmptyObject(display)) {
                        paramsTemp.sortIndex = options.sortIndex ? options.sortIndex - 1 : 0;

                        if (paramsTemp.sortIndex > (display.length - 1)) {
                            paramsTemp.sortIndex = 0;
                        }

                        paramsTemp.sortColumn = display[paramsTemp.sortIndex];
                        if (paramsTemp.sortColumn && !options.sortAsc) {
                            paramsTemp.sortColumn = paramsTemp.sortColumn + " DESC";
                        } else {
                            paramsTemp.sortColumn = paramsTemp.sortColumn + " ASC";
                        }
                    }

                    obsparams.paramsJson = ko.toJSON(paramsTemp);
                    obsparams.url = $(location).attr("href");

                    return obsparams;
                } else {
                    self.observableData({
                        maxCount: 0,
                        rows: []
                    });
                }
            };

            self.setObsParams = function(optschanged) {

                var obsparams = self.getObsParams(optschanged);
                if (!obsparams) {
                    return;
                }

                if (self.widgetSignals) {
                    self.widgetSignals.dataRequested.dispatch();
                }

                params.observableParamsList[0](obsparams);
            };

            self.subscriptions.push(params.viewLevelOptions.subscribe(self.setObsParams));
            self.subscriptions.push(self.selectedDateRangeValues.subscribe(self.setObsParams));

            self.subscriptions.push(self.observableOptions.subscribe(function () { self.setObsParams(true); }));

            self.subscriptions.push(self.observableData.subscribe(function () {
                self.DataUpdated();
            }));

            self.setObsParams(false);
        }

        EndpointHistoricalCalls.prototype.RefreshData = function () {
            var self = this;

            var options = self.observableOptions();
            var data = self.observableData();

            if (!$.isEmptyObject(data)) {
                if (data.displayDetail && (!options.displayDetail || (options.displayDetail.length === 0))) {

                    options.displayDetail = $.extend([], data.displayDetail);

                    if (data.colOptionsDetail && (!options.colOptionsDetail || (options.colOptionsDetail.length === 0))) {
                        options.colOptionsDetail = data.colOptionsDetail;
                    }

                    self.observableOptions(options);
                }
            }
        };

        EndpointHistoricalCalls.prototype.DataUpdated = function () {
            var self = this;
            self.RefreshData();
        };

        EndpointHistoricalCalls.prototype.dispose = function() {
            var self = this;
            self.subscriptions.forEach(function(sub) {
                sub.dispose();
            });

        };
        export default { viewModel: EndpointHistoricalCalls, template: templateMarkup };

    
